// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__l7ZXq","search":"Settings_search__1phlp","filter":"Settings_filter__3AjQI"};